import { useId, useLayoutEffect, useRef, useState } from 'react'
import { fmtBRL, updateDeal } from '../../db/api.js'

// Comissão por negócio: comissao_percentual (0–100) sobre o valor do negócio, já com descontos.
// No modo demo a prévia fica em memória.
const demoCommissions = new Map()
const isDemo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
export default function DealCommission({ dealId, total, percent: savedPercent, onSaved }) {
  const formId = useId()
  const [percent, setPercent] = useState(() => Number((isDemo ? demoCommissions.get(dealId) : savedPercent) || 0))
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const input = useRef(null)
  useLayoutEffect(() => {
    if (editing) input.current?.setSelectionRange(draft.length, draft.length)
  }, [editing, draft])
  function changePercent(event) {
    const digits = event.target.value.replace(/\D/g, '').replace(/^0+/, '') || '0'
    const padded = digits.padStart(3, '0')
    setDraft(`${padded.slice(0, -2)},${padded.slice(-2)}`)
    setError('')
  }
  const formatted = percent.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const amount = Math.round(Number(total || 0) * percent) / 100
  async function save(event) {
    event.preventDefault()
    if (saving) return
    const value = Number(draft.trim().replace(',', '.'))
    if (!draft.trim() || !Number.isFinite(value) || value < 0 || value > 100) {
      setError('Informe um percentual entre 0 e 100.'); return
    }
    const next = Math.round(value * 100) / 100
    if (isDemo) demoCommissions.set(dealId, next)
    else {
      setSaving(true)
      try {
        const updated = await updateDeal(dealId, { comissao_percentual: next })
        onSaved?.(updated)
      } catch (err) { setError(err.message || 'Não foi possível salvar a comissão.'); setSaving(false); return }
      setSaving(false)
    }
    setPercent(next); setEditing(false); setError('')
  }
  return <div onKeyDown={(event) => { if (editing && event.key === 'Escape') { event.stopPropagation(); setEditing(false); setError('') } }}>
    <div className="cv-data-row dp-deal-commission">
      <span className="cv-data-label">Comissão</span>
      <div className="dp-price-inline">
        {editing ? <form id={formId} className="dp-price-inline" onSubmit={save}>
          <input ref={input} autoFocus aria-label="Percentual de comissão" inputMode="numeric" autoComplete="off" value={draft} style={{ width: `${Math.max(draft.length, 3)}ch` }} onChange={changePercent} /><span>%</span>
        </form> : <button type="button" className="dp-price-value cv-data-value" aria-label={`Editar comissão: ${formatted}%`} onClick={() => { setDraft(formatted); setError(''); setEditing(true) }}>{formatted}%</button>}
        <span>· {fmtBRL(amount)}</span>
      </div>
    </div>
    {editing && <div className="dp-price-actions"><button type="submit" form={formId} disabled={saving}>{saving ? 'Salvando…' : 'Salvar'}</button><button type="button" disabled={saving} onClick={() => { setEditing(false); setError('') }}>Cancelar</button></div>}
    {error && <small role="alert" className="dp-commission-error">{error}</small>}
  </div>
}
